<template>
    <div id="SubidorIncidencias_div" class="w-100 px-0 py-0">
        <div id="TituloGestionIncidencias_div">
            <h5 style="margin-bottom: 0px;">CONTROL DE ASISTENCIAS</h5>
            <h6 style="margin-top: 0px;">Exportación de Registros del Reloj Checador</h6>
        </div>
        <div class="row d-flex">
            <div class="col-12 col-sm-12 col-md-12 col-lg-4 padding-div-low">
                <div class="area">
                    <div class="row">
                        <div class="form-group col-12" >
                            <label>Seleccione Mes del período</label>
                            <input type="month" id="fechaInicio" v-model="mesExportar" class="form-control" style="width: 100%" @change="cambiarMes($event)"/>
                        </div>
                    </div>
                    <div class="row">
                        <div class="form-group col-12" >
                            <label>Seleccione Quincena</label>
                            <select id="catalogodePeriodos" class="form-control" @change="cambiarPeriodo($event)">
                                        <option value= 0>Seleccione Quincena</option>
                                        <option v-for="option in Periodos" v-bind:value="option.id" >{{ option.value }}</option>
                                    </select>
                        </div>
                    </div>
                    <div class="row">
                        <div class="form-group col-12" >
                            <label>Seleccione el archivo Excel a exportar</label>
                            <input type="file" id="archivoaSubir" v-on:change="cargarArchivo($event)" class="form-control" accept=".xls, .xlsx" style="width: 100%"/>
                        </div>
                    </div>
                    <div class="text-right">
                        <button class="btn btn-dark"  @click='Subir()' v-if="archivo!=null">Exportar Registros</button>
                    </div>
                </div>
            </div>
            <div class="col-12 col-sm-12 col-md-12 col-lg-8 padding-div-low" v-if="NumerosNomina!=''">
                <div class="area">
                    <div class="row">
                        <h6>Numero de Nómina Omitidos:</h6>
                    </div>

                    <div class="row">
                        <label>{{this.NumerosNomina}}</label>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import comun from '@/../static/js/comun'
import enumeraciones from '@/../static/js/enumeraciones'
import api from '@/../static/js/api'
import router from '@/router/index'
import axios from 'axios'

export default {
    data(){
    return {
            enumeraciones,
            archivo: null,
            urlDocumento: "",
            fechaInicio: "",
            fechaFinal : "",
            mesExportar : moment().format('YYYY-MM'),
            parametros: {
                extensionDocumento: ['xls', 'xlsx'],
            },
            Periodos:[
                {id: 1, value: "Primera Quincena"},
                {id: 2, value: "Segunda Quincena"}
            ],
            NumerosNomina:""
        }
    },
    methods: {
        cargarArchivo:function(evento){
             if(this.verificaQueSeaElDocumentoCorrecto(evento)) {                                 
                this.archivo = evento.target.files[0];   
            }           
        },
        verificaQueSeaElDocumentoCorrecto: function(evento) {
            let siEsUnDocumentoValido = false;      
            //Se verifica que haya documento
            if(evento.target.files.length <= 0) {          
            $("#archivoaSubir").val('');
            this.archivo = null;     
            this.mensajeVisor = 'No hay ruta de archivo. Favor de volver a intentar.' 
            return siEsUnDocumentoValido;    
            }

            const nombreCortado = evento.target.files[0].name.split(".");        
            if (this.parametros.extensionDocumento.find(element => element.toLowerCase() == nombreCortado[nombreCortado.length - 1].toLowerCase()) != null)
            siEsUnDocumentoValido = true;
            else{
            let extensiones = "";
            this.parametros.extensionDocumento.forEach((element, index) => {
                extensiones += " ." + element;
                if(index < this.parametros.extensionDocumento.length - 1)
                extensiones += ",";
            });
            comun.mensajeDeAlerta("El documento que esta subiendo no es un archivo valido. El archivo debe ser " + extensiones + ".<br/><br/>Verifique el documento e inténtelo de nuevo.", null, null);
            $("#archivoaSubir").val('');
            this.archivo = null; 
            
            return siEsUnDocumentoValido;
            }
            
            return siEsUnDocumentoValido;
        },
        Subir: function(){
            if(this.archivo!=null)
            {
                // if(this.ValidarFechas()== true)
                // {
                    comun.SeEstaCargandoInformacion(true); 
                    var datosDelFormulario = new FormData();
                    datosDelFormulario.append("Archivo", this.archivo);
                    datosDelFormulario.append("FechaInicio", this.fechaInicio);
                    datosDelFormulario.append("FechaFinal", this.fechaFinal);
                    axios.post(api.conexion + api.SIAP.funcion.ExpotarDocumentoChecador, datosDelFormulario,
                        comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, true)
                    ).then(respuesta => { 
                        if(respuesta.data.SiHayError){
                            this.archivo = null;
                            this.NumerosNomina = "";
                            $("#archivoaSubir").val('');
                            console.log(respuesta);
                            comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);                  
                        } else { 

                            if(respuesta.data.Satisfactorio!=null)
                            {
                                comun.mensajeDeAlerta(respuesta.data.Satisfactorio, null, null);
                                this.NumerosNomina = respuesta.data.aVerificar;
                            }
                            else
                            {
                                if(respuesta.data.Registrados == 0)
                                {
                                    comun.mensajeDeAlerta("El Archivo no contiene registros o formato incorrecto", null, null);
                                }
                            }
                             
                            
                            
                            this.archivo = null;
                            this.mesExportar = moment().format('YYYY-MM');
                            $("#catalogodePeriodos option[value='0']").prop("selected",true);
                            $("#archivoaSubir").val('');
                        }
                        comun.SeEstaCargandoInformacion(false);
                    }
                    ).catch(excepcion => {
                        console.log(excepcion);
                        comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null);
                        comun.SeEstaCargandoInformacion(false);                
                    });    
                //}
            }
        },
        ValidarFechas(){
            var diff1= moment().diff(moment(this.fechaInicio), 'days');
            var diff2 = moment().diff(moment(this.fechaFinal), 'days');
            
            if(this.fechaInicio > this.fechaFinal)
            {
                comun.mensajeDeAlerta("El inicio del período no puede ser mayor a final", null, null);
                return false;
            }
            if(diff1<=0 || diff2<=0)
            {
                comun.mensajeDeAlerta("El período a exportar no puede integrarse por fechas iguales o superiores a dia corriente", null, null);
                return false;
            }
            if(this.Periodos.id == undefined )
            {
                comun.mensajeDeAlerta("Seleccione una Quincena del mes seleccionado", null, null);
                return false;
            }
            return true;
        },
        cambiarPeriodo(datos){
            if(datos.target.value!= 0)
            {
                this.Periodos.id = parseInt(datos.target.value);
                switch(parseInt(datos.target.value))
                {
                    case 1:
                        this.fechaInicio = this.mesExportar + "-01";
                        this.fechaFinal = this.mesExportar + "-15";
                        
                        break;
                    case 2:
                        this.fechaInicio = this.mesExportar + "-16";
                        this.fechaFinal = this.mesExportar + "-" + moment(this.mesExportar ).daysInMonth();

                        break;
                }
            }
        },
        cambiarMes(){
             $("#catalogodePeriodos option[value='0']").prop("selected",true);
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/SIAP/Checador/ExportarDeExcel.vue